import { useMemo } from "react";
import { levels } from "config/levels";

export const useImagesPreloader = () => {
  const imagesUrls = useMemo(
    () =>
      levels.reduce(
        (images, level) => [...images, level.fullImage, ...level.tiles],
        [],
      ),
    [],
  );

  return { imagesUrls };
};
